import React from 'react';
import { Reveal } from './Reveal';
type SectionHeadingProps = {
  eyebrow?: string;
  title: React.ReactNode;
  description?: React.ReactNode;
  align?: 'center' | 'left';
};
export function SectionHeading({
  eyebrow,
  title,
  description,
  align = 'center'
}: SectionHeadingProps) {
  const alignment = align === 'center' ? 'mx-auto max-w-3xl text-center' : 'max-w-3xl text-left';
  return <Reveal className={alignment} data-id="element-39" data-mp="bjtwnu4nck12">
      {eyebrow ? <p className="text-[12px] font-medium uppercase tracking-[0.1em] text-gold" data-id="element-40" data-mp="bl5bqq3jle7h">
          {eyebrow}
        </p> : null}
      <h2 className="mt-4 text-3xl font-bold leading-[1.1] tracking-tight text-ice sm:text-4xl lg:text-[44px]" data-id="element-41" data-mp="glau1fnx9ocw">
        {title}
      </h2>
      {description ? <p className="mt-5 text-[17px] leading-[1.7] text-cool" data-id="element-42" data-mp="6slot2iyt6q0">{description}</p> : null}
    </Reveal>;
}